const global = null
export default {
  global,
}



// WEBPACK FOOTER //
// ./src/plugins/global.js